<template>
	<div :class="panel_type">
		<div class="panel-heading" v-if="hasHeader" v-bind="titleAttributes">
			<h6 class="panel-title" ref="title" ><slot name="panel-title"></slot></h6>
			<div class="heading-elements" v-if="hasHeadingElements">
				<slot name="header-custom"></slot>
				<div class="heading-btn" v-if="hasHeadingButtons">
					<slot name="heading-btn"></slot>
				</div>
				<ul class="icons-list" v-if="hasIcons">
					<li v-if="hasCollapse">
						<a data-action="collapse2" data-popup="tooltip" :title="isExpanded ? 'Collapse' : 'Expand'" @click="toggleExpanded"
						   :class="{ 'rotate-180': ! isExpanded }"
						   :data-original-title="isExpanded ? 'Collapse' : 'Expand'"
						>
						</a>
					</li>
					<li v-if="hasCancel">
						<a data-action="cancel2" data-popup="tooltip" :title="cancelTooltip" @click.prevent="hide"></a>
					</li>
				</ul>
			</div>
		</div>

		<div class="panel-body" :id="bodyId" v-if="hasBody && isExpanded" ref="body">
			<slot></slot>
		</div>

	</div>
</template>

<script>
    export default {
        props: {
            titleAttributes:{
                type: Object,
                default: () => {
                    return {};
                }
			},
            type: {
                default: 'panel-default',
                type: String
            },
            header: {
                default: true,
                type: Boolean
            },
            collapse: {
                default: true,
                type: Boolean
            },
            cancel: {
                default: false,
                type: Boolean
            },
            bodyId: {
                default: null
            },
            cancelTooltip: {
                type: String,
                default: 'Cancel'
            },
            body: {
                default: true,
                type: Boolean
            },
            expanded: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                hasBody: this.body,
                hasCollapse: this.collapse,
                hasHeader: this.header,
                hasCancel: this.cancel,
                isExpanded: this.expanded
            };
        },
        computed: {
            panel_type() {
                var classes = ['panel'];
                classes.push(this.type);
                return classes;
            },
            hasHeadingElements() {
                if (this.hasCollapse || this.hasCancel || this.hasHeadingButtons) {
                    return true;
                }
                return false;
            },
            hasIcons() {
                if (this.hasCollapse || this.hasCancel || this.hasHeadingButtons || this.hasHeaderCustom) {
                    return true;
                }
                return false;
            },
            hasHeaderCustom() {
                return !!this.$slots['header-custom'];
            },
            hasHeadingButtons () {
                return !!this.$slots['heading-btn']
            },
            hasTitle() {
                return !!this.$slots['panel-title'];
            }
        },
        mounted() {
            if (! this.hasTitle) {
                $(this.$refs.title).html('&nbsp;');
            }
        },
        methods: {
            hide() {
                this.$emit('hide-panel');
            },
            toggleExpanded() {
                this.isExpanded = ! this.isExpanded;
                this.$emit('toggle-expand', this.isExpanded);
            }
        },
        watch: {
            isExpanded: function (expanded) {
                if (expanded) {
                    $(this.$refs.body).slideDown('fast');
                } else {
                    $(this.$refs.body).slideUp('fast');
                }
            }
        }
    }
</script>
